// extracted by mini-css-extract-plugin
export var errorIcon = "_kh-1";
export var nameLogo = "_kh-0";